/**
 * 触达渠道配置
 */
import api from '@/services/api'
import { METHOD, request } from '@/utils/request'

export const dataApi = {
  /**
   * 分页查询触达渠道列表
   */
  async queryPage(param) {
    return request(api.clue.CLUETOUCHCHANNEL + '/queryPage', METHOD.POST, param)
  },

  /**
   * 根据ID查询触达渠道详情
   */
  async getById(id) {
    return request(api.clue.CLUETOUCHCHANNEL + '/getById', METHOD.GET, { id })
  },

  /**
   * 新增触达渠道
   */
  async add(param) {
    return request(api.clue.CLUETOUCHCHANNEL + '/add', METHOD.POST, param)
  },

  /**
   * 修改触达渠道
   */
  async update(param) {
    return request(api.clue.CLUETOUCHCHANNEL + '/update', METHOD.POST, param)
  },

  /**
   * 删除触达渠道
   */
  async delete(id) {
    return request(api.clue.CLUETOUCHCHANNEL + '/delete', METHOD.POST, { id })
  },

  /**
   * 查询所有触达渠道（用于下拉框）
   */
  async getAllChannels() {
    return request(api.clue.CLUETOUCHCHANNEL + '/queryAll', METHOD.GET)
  }
}

export default { dataApi }
